module.exports = __webpack_public_path__ + "img/65 (1).68988321.png";